import React from 'react';
import { Typography, ProductCardsSection } from 'common/components';
import { css } from 'linaria';
import { ENTRANCE_DOORS_ELEMENT_BLOCK } from '../../entrance-doors-constants';
import {
  ENTRANCE_DOORS_SPECIAL_SECTION_LIST,
  SpecialDoorStructure,
} from './entrance-doors-special-section-constants';

const entranceDoorsSpecialSectionImg = css`
  width: 144px;
  height: 144px;
  margin-bottom: 24px;
`;

const entranceDoorsSpecialSectionName = css`
  margin-bottom: 16px;
`;

const entranceDoorsSpecialSectionSlide = css`
  && {
    width: 163px;

    @media (--only-desktop) {
      width: 205px;
    }

    @media (--only-tablet) {
      width: 193px;
    }

    @media (--only-mobile) {
      width: 204px;
    }
  }
`;

export const EntranceDoorsSpecialSection: React.FC = () => (
  <ProductCardsSection
    elementBlock={ENTRANCE_DOORS_ELEMENT_BLOCK}
    title="Двери специального назначения"
    productList={ENTRANCE_DOORS_SPECIAL_SECTION_LIST}
    renderProductCard={({ name, text, alt, imgSrc }: SpecialDoorStructure) => (
      <>
        <img
          className={entranceDoorsSpecialSectionImg}
          alt={alt}
          src={imgSrc}
          title={name}
          width="144"
          height="144"
        />
        <Typography className={entranceDoorsSpecialSectionName} adaptive={false} size="subtitle" variant="m">
          {name}
        </Typography>
        <Typography adaptive={false} size="body_long" variant="s">
          {text}
        </Typography>
      </>
    )}
    swiperSlideClassName={entranceDoorsSpecialSectionSlide}
  />
);
